<template>
    <div class="content-wrapper">
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>
        <breadcrumb :page="$t('form.student.statusImportPreview')"></breadcrumb>
        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{ alertMessage }}</b-alert>
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">{{ $t('form.student.statusImportPreview') }}</h3>
                        <button v-show="statusList.length > 0" type="submit"
                            class="btn btn-primary float-right" @click="acceptStatusFile">
                            {{ $t('form.student.import') }} {{ statusList.length }} {{ $t('form.student.record') }}
                            <span v-show="statusList.length > 1">(s)</span>
                        </button>
                        <button type="submit" class="btn btn-danger float-right mr-3" @click="rejectStatusFile">
                            {{ $t('button.cancel') }}
                        </button>
                    </div>
                    <div class="card-body">
                        <div v-if="statusList.length > 0 || incorrectRecords.length > 0" class="mb-3">
                            <span class="badge badge-success">{{ $t('form.student.validRecords', { count: statusList.length }) }}</span>
                            <span class="badge badge-danger ml-2">{{ $t('form.student.errorRecords', { count: incorrectRecords.length }) }}</span>
                        </div>
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover" v-if="statusList.length > 0 || incorrectRecords.length > 0">
                                <thead>
                                    <tr class="header">
                                        <th>{{ $t('form.student.studentNumber') }}</th>
                                        <th>{{ $t('form.student.partnerCode') }}</th>
                                        <th>{{ $t('form.student.status') }}</th>
                                        <th>{{ $t('form.student.notes') }}</th>
                                        <th>{{ $t('form.student.statusDate') }}</th>
                                        <th>{{ $t('form.student.error') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(record, index) in incorrectRecords" v-bind:key="'err' + index">
                                        <td style="color:red" v-for="(td, tdindex) in record" v-bind:key="'td' + tdindex">{{ td }}</td>
                                    </tr>
                                    <tr v-for="(row, index) in statusList" v-bind:key="'ok' + index">
                                        <td v-for="(td, tdindex) in row" v-bind:key="'td' + tdindex">{{ td }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p class="p-3 m-0" v-else>{{ $t('noRecordFound') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['permissions'],
    data() {
        return {
            statusList: [],
            incorrectRecords: [],
            filePath: '',
            alert: false,
            alertClass: '',
            alertMessage: '',
            isLoading: false,
            fullPage: true
        };
    },
    mounted() {
        if (!this.permissions.createImportGraduations) {
            this.$router.push('/');
        }
        this.setLocalVariableData();
    },
    methods: {
        setLocalVariableData() {
            let list = window.localStorage.getItem('statuses');
            if (list) {
                const parsed = JSON.parse(list);
                this.incorrectRecords = parsed.incorrectRecords || [];
                this.statusList = parsed.correctRecords || [];
                this.filePath = window.localStorage.getItem('statusPath');
            }
        },
        rejectStatusFile() {
            this.isLoading = true;
            axios.post('/api/students/cancel-import', { path: this.filePath })
                .then(() => { this.isLoading = false; this.clearLocal(); this.$router.go(-1); })
                .catch(() => { this.isLoading = false; this.clearLocal(); this.$router.go(-1); });
        },
        acceptStatusFile() {
            let formData = new FormData();
            formData.append('statuses', JSON.stringify(this.statusList));
            formData.append('previewErrors', JSON.stringify(this.incorrectRecords));
            formData.append('path', this.filePath);
            this.isLoading = true;

            axios.post('/api/status/save', formData)
                .then(response => {
                    this.isLoading = false;
                    window.localStorage.setItem('dataSaved', response.data.message);
                    this.clearLocal();
                    this.$router.push('/status-import');
                })
                .catch(error => {
                    this.isLoading = false;
                    this.showAlert(error, 'danger');
                });
        },
        clearLocal() {
            window.localStorage.removeItem('statuses');
            window.localStorage.removeItem('statusPath');
        },
        showAlert(msg, cls = 'success') {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        }
    }
};
</script>